import { logger } from '../common';
export var onEmailCopy = function onEmailCopy(email) {
  // try catch is for the clipboard function
  try {
    void navigator.clipboard.writeText(email);
  } catch (error) {
    logger.error(error);
  }
};
export function trimARI(ari) {
  return ari.split('/').pop() || '';
}
var MAX_CONTRIBUTORS = 3;
export var sanitizeAndMapRecentWorkActivity = function sanitizeAndMapRecentWorkActivity(recentWork) {
  var uniqRecents = new Set();
  return recentWork.reduce(function (result, recentWorkItem) {
    var containerName = recentWorkItem.containers.length > 0 ? recentWorkItem.containers[0].name : recentWorkItem.object.product;
    // creating a key with the container name and title to
    // prevent the posibilty of multiple items with the same name
    var key = "".concat(containerName, ":").concat(recentWorkItem.object.name || '');
    if (uniqRecents.has(key)) {
      return result;
    }
    uniqRecents.add(key);
    var curRecentWorkItem = {
      title: recentWorkItem.object.name || '',
      url: recentWorkItem.object.url,
      containerName: containerName,
      event: recentWorkItem.eventType,
      timestamp: recentWorkItem.timestamp,
      iconUrl: !!recentWorkItem.object.icon ? recentWorkItem.object.icon.value : '',
      contributors: recentWorkItem.contributors.slice(0, 3).map(function (contributor) {
        return {
          name: contributor.name,
          id: contributor.accountId
        };
      }),
      othersCount: recentWorkItem.contributors.length > MAX_CONTRIBUTORS ? recentWorkItem.contributors.length - MAX_CONTRIBUTORS : 0
    };
    return result.concat(curRecentWorkItem);
  }, []);
};
/**
 * Formats the time for a person knowledge card based on locale of the viewing user and zoneInfo for the surfaced users.
 **/
export var formatTimeKnowledgeCard = function formatTimeKnowledgeCard(_ref) {
  var locale = _ref.locale,
    zoneInfo = _ref.zoneInfo;
  return zoneInfo ? new Date().toLocaleTimeString(locale, {
    timeZone: zoneInfo,
    hour: 'numeric',
    minute: 'numeric'
  }).replace(' ', '').toLowerCase() : undefined;
};